export default "__VITE_ASSET__31b2e990__"